import React from 'react'
import {
  Button,
  Typography,
  TableRow,
  TableCell,
  Checkbox,
  Tooltip
} from '@material-ui/core';

import * as defs from '../PurchaseOrder.module.scss';

import PlaylistAddCheckIcon from '@material-ui/icons/PlaylistAddCheck';

export default function LineItem({lineItem, editable, onStartEdit, onDeleteItem, columnWidths, costCentres}) {

  if (!costCentres) return null;
  
  const costCentre = costCentres.filter(cc => cc.id === lineItem.costCentre.id)[0].name;

  return (
    <TableRow>
      <TableCell width={columnWidths.description}>
        <Typography>{lineItem.description}</Typography>
      </TableCell>
      <TableCell width={columnWidths.costCentre}>
        <Typography>{costCentre}</Typography>
      </TableCell>
      <TableCell align='right' width={columnWidths.quantity}>
        {lineItem.quantity === lineItem.received && <div className={defs.receivedIcon}><Tooltip title='All received'><PlaylistAddCheckIcon style={{fontSize: '18px'}} /></Tooltip></div>}
        <Typography>{lineItem.quantity}</Typography>
      </TableCell>
      <TableCell width={columnWidths.cost}>
        <Typography align='right'>{lineItem.cost.toFixed(2)}</Typography>
      </TableCell>
      <TableCell align='right' width={columnWidths.totalPrice}>
        <Typography>£{lineItem.totalPrice.toFixed(2)}</Typography>
      </TableCell>
      <TableCell width={columnWidths.buttons}>
        <Button className={defs.smallLineItemButton} fullWidth color="primary" variant="outlined" disabled={!editable} onClick={onStartEdit}>Edit</Button>
        <Button
          className={defs.smallLineItemButton}
          fullWidth
          color="primary"
          variant="outlined"
          style={{ height: '100%', display: 'inline-block' }}
          onClick={onDeleteItem}
          disabled={!editable}
        >Delete</Button>
      </TableCell>
    </TableRow>
  )
}
